import { Map, OrderedSet } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import { combineReducers } from 'redux-immutable'
import * as actions from './actions'

const status = handleActions({
  [combineActions(
    actions.fetchAttributes,
    actions.fetchAttributesPending,
    actions.fetchAttributesFailed,
    actions.fetchAttributesCancelled,
    actions.receiveAttributes,
  )]: (state, action) => action.type
}, Map())

const properties = handleActions({
  [actions.receiveAttributes]: (state, action) => {
    return action.payload.properties
  }
}, OrderedSet())

const events = handleActions({
  [actions.receiveAttributes]: (state, action) => {
    return action.payload.events
  }
}, OrderedSet())

export default combineReducers({ status, properties, events })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/attribute/reducer.js